import { ADMIN_LOGIN, LOGOUT } from "../actions/auth";
import { REQUEST, SUCCESS, FAILURE } from "../actions";
import jwt_decode from "jwt-decode";

const initialState = {
  token: null,
  user: {},
  loading: false,
  isAuthenticated: false,
  error: ""
};
export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_LOGIN[REQUEST]:
      return {
        ...state,
        loading: true
      };
    case ADMIN_LOGIN[SUCCESS]:
      return {
        ...state,
        loading: false,
        token: action.payload,
        isAuthenticated: true,
        user: jwt_decode(action.payload)
      };
    case ADMIN_LOGIN[FAILURE]:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case LOGOUT: {
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        user: {}
      };
    }
    default:
      return state;
  }
};
